/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useContext, useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import beyown_logo from '../../assets/img/logo_main.png';
import Badge from 'react-bootstrap/Badge';
import firebase from "../../firebase/firebase-config";
// import firebase from "firebase/app";
import { auth } from "../../firebase/firebase-config";
import { onAuthStateChanged, signOut, signInWithEmailAndPassword } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader
} from "reactstrap";
import { Link, Redirect, useHistory } from "react-router-dom";
import { toast, Toast, ToastContainer } from 'react-toastify';
import { GoogleLoginContext } from "../../contexts/GoogleLoginContext";
import { GoogleLogout, useGoogleLogout } from "react-google-login";
import NotificationDisplay from "../NotificationDisplay";

// import firebase from "../../firebase/firebase-config";


const AdminNavbar = (props) => {
  let history = useHistory();
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");
  const { profile, ProfileRemoved, clientId } = useContext(GoogleLoginContext);
  const [user_data, setUser_data] = useState({});
  const [NewNotifications, setNewNotifications] = useState([])
  const [oldNotifications, setoldNotifications] = useState([])
  // const { GsignOut, loaded } = useGoogleLogout({
  //   onFailure,
  //   clientId,
  //   onLogoutSuccess
  // })
  React.useEffect(() => {
    window.addEventListener("resize", updateColor);

    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });
  // useEffect(() => {
  //   getAllNotificaitons();
  // }, [NewNotifications])

  const getAllNotificaitons = async () => {
    var noti = [];
    var oldNoti = [];
    await firebase.firestore().collection('NotificationsAdmin').where('isNew', '==', true).onSnapshot(async (notiData) => {
      notiData.docs.forEach((data) => {
        console.log(data.data());
        noti.push(data?.data());

      })
      setNewNotifications(noti);
    })

    await firebase.firestore().collection('NotificationsAdmin').where('isNew', '==', false).onSnapshot(async (notiData) => {
      notiData.docs.forEach((data) => {
        // console.log(data.data());
        oldNoti.push(data?.data());

      })
      setoldNotifications(oldNoti);
    })
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };
  // this function is to open the Search modal
  const toggleModalSearch = () => {
    setmodalSearch(!modalSearch);
  };

  // const [user, setuser] = useState({})


  useEffect(() => {
    const loggedInUser = localStorage.getItem("authenticated");
    const User_uid = localStorage.getItem("user_id");
    GetMyUser();




  }, []);

  const [user, loading] = useAuthState(auth);
  async function GetMyUser() {
    firebase.firestore().collection('admins').doc(user?.uid).onSnapshot((snapshot) => {


      return setUser_data(snapshot.data());
    })

  }
  const logout = async (e) => {
    e.preventDefault();

    toast.success('User has been logged out Successfully', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    })
    console.log(profile);

    await signOut(auth);
    document.getElementsByClassName('Google_logout')[0].click();

    // setauthenticated(false)
    localStorage.removeItem("authenticated");
    console.log('logged out');


    history.push('/Login');



  }




  // console.log(document.getElementsByClassName('Google_logout')[0]);
  // console.log(clientId);

  return (
    <>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg">
        <div style={{ display: "none" }} >
          <GoogleLogout clientId={clientId} className='Google_logout' buttonText="Log out" onLogoutSuccess={ProfileRemoved} />
        </div>

        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
              {/* {props.brandText} */}
              <div style={{ height: '60px' }}> <img className="img-fluid" style={{ height: '100%' }} src={beyown_logo} /></div>





            </NavbarBrand>

          </div>

          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>

          <Collapse navbar isOpen={collapseOpen}>

            <Nav className="ml-auto" navbar>

              <InputGroup className="search-bar">
                <Button color="link" onClick={toggleModalSearch}>
                  <i className="tim-icons icon-zoom-split" />
                  <span className="d-lg-none d-md-block">Search</span>
                </Button>
              </InputGroup>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                >
                  {/* <div className="notification d-none d-lg-block d-xl-block" >
                    1
                  </div> */}

                  <i className="tim-icons icon-bell-55" />
                  <Badge>{NewNotifications.length == 0 ? '' : NewNotifications.length}</Badge>

                  {/* <Badge ></Badge>
                   */}
                  <p className="d-lg-none">Notifications</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar bg-black " right tag="ul">
                  <div className="d-flex">
                    <p className="ml-2  " style={{ color: "black" }}>New</p>
                    <p className="bg-primary text-white ml-2 rounded px-1">{NewNotifications.length == 0 ? '' : NewNotifications.length}</p>
                  </div>

                  {NewNotifications.map((notiData, i) => {
                    return notiData.type
                    // <NotificationDisplay Linkdata={``} notiData={} notiDesc={} key={i} />

                  })
                  }
                  <p className="ml-2 bg-dark-subtle " style={{ color: "black" }}>old</p>
                  {/* {oldNotifications.map((notiData) => {
                    return <Link to={`/admin/Total-Orders/Single-Order/${notiData.orderId}`} >
                      <NavLink href={`/admin/Total-Orders/Single-Order/${notiData.orderId}`} tag="li" className="border-2 mx-2" style={{ backgroundColor: 'ThreeDDarkShadow', borderRadius: '12px' }}>
                        {notiData.type == 'newOrder' ? <DropdownItem className="m-0 px-1" >
                          <div className="d-flex  ">
                            <img alt="new order" src={notiData.mediaUrl} width={20} />
                            <div>

                              <p className="text-white  ml-2
                        " style={{ textOverflow: 'ellipsis' }}>{truncate('A new order has been recieved in the system.')}

                              </p>
                            </div>
                          </div>
                        </DropdownItem> : ''}

                      </NavLink>
                    </Link>
                  })
                  } */}

                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img alt={user_data?.profilePicture} src={user_data?.profilePicture} />
                    {/* <p>{user_data?.firstName}</p> */}
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none"  >Log out</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    <Link to="/admin/user-profile"><DropdownItem className="nav-item">Profile</DropdownItem></Link>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Settings</DropdownItem>
                  </NavLink>
                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item" onClick={logout}>Log out </DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <ModalHeader>
          <Input placeholder="SEARCH" type="text" />
          <button
            aria-label="Close"
            className="close"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>
      <ToastContainer />
    </>
  );
}


export default AdminNavbar;
